// extracted by mini-css-extract-plugin
export default {"root":"NavigationBar_root__cMmG6","action":"NavigationBar_action__+qDAG","title":"NavigationBar_title__agWjT"};